function getDynamicCellEditor() {
  function dynamicEditor() { }
  dynamicEditor.prototype.init = function (params) {
    this.eGui = document.createElement('div');
    this.eGui.style =
      'height:100%;width:' + params.column.actualWidth + 'px';
    this.selectEle = document.createElement('input');
    this.selectEle.style =
      'position:relative; height:100%;width:' +
      params.column.actualWidth +
      'px';
    this.selectEle.id = 'mySelect';
    this.selectEle.class = 'mySelect';

    this.selectEle = document.createElement('input');
    this.selectEle.value = params.value || null
    this.eGui.appendChild(this.selectEle);

    this.selectized = $(this.selectEle).selectize({   //<--- add selectize
      delimiter: ',',
      persist: false,
      create: true
    })
  };
  dynamicEditor.prototype.getGui = function () {
    return this.eGui;
  };
  dynamicEditor.prototype.afterGuiAttached = function () {
    this.selectized[0].selectize.focus();
  };
  dynamicEditor.prototype.getValue = function () {
    return this.selectEle.value;
  };
  dynamicEditor.prototype.destroy = function () { };
  dynamicEditor.prototype.isPopup = function () {
    return true;  //as popup
  };
  return dynamicEditor;
}

function getDynamicSelectEditor() {
  function dynamicSelectEditor() { }
  dynamicSelectEditor.prototype.init = function (params) {
    this.eGui = document.createElement('div');
    this.eGui.style =
      'height:100%;width:' + params.column.actualWidth + 'px';
    //Create and append select list
    this.selectEle = document.createElement('select');
    this.selectEle.style =
      'position:relative; height:100%;width:' +
      params.column.actualWidth +
      'px';
    this.selectEle.id = 'mySelect';
    this.selectEle.class = 'mySelect';

    this.selectEle = document.createElement('select');

    this.eGui.appendChild(this.selectEle);
    options = []
    DeveloperGrid._units.forEach((unit) => { options.push({ text: unit, value: unit }) })
    $(this.selectEle).selectize({   //<--- add selectize
      items: [params.value || params.node.data.unit],
      options: options,
      sortField: 'text'
    });
  };
  dynamicSelectEditor.prototype.getGui = function () {
    return this.eGui;
  };
  dynamicSelectEditor.prototype.afterGuiAttached = function () {
    this.eGui.focus();
    // this.eGui.select();
  };
  dynamicSelectEditor.prototype.getValue = function () {
    return this.selectEle.value;
  };
  dynamicSelectEditor.prototype.destroy = function () { };
  dynamicSelectEditor.prototype.isPopup = function () {
    return true;  //as popup
  };
  return dynamicSelectEditor;
}

window.DeveloperGrid = {
  _units: [],
  _grid: null,
  _removedRows: [],
  _gridOptions: {
    rowData: null,
    onGridReady(e) {
      return e.api.sizeColumnsToFit();
    },
    onGridSizeChanged(event) {
      return event.api.sizeColumnsToFit();
    },
    singleClickEdit: true,
    headerHeight: 44,
    rowHeight: 94,
    suppressPaginationPanel: true,
    animateRows: true,
    suppressRowClickSelection: true,
    toolPanelSuppressSideButtons: true,
    suppressContextMenu: true,
    stopEditingWhenGridLosesFocus: true,
    rowBuffer: 1000,
    domLayout: 'autoHeight',
    defaultColDef: {
      sortable: true,
      resizable: true
    },
    onColumnResized: function (params) { params.api.resetRowHeights() },
    columnDefs: [
      {
        field: 'serial',
        headerName: '#',
        width: 40,
        minWidth: 40,
        maxWith: 40,
        cellClass: 'super-small-text',
        suppressSizeToFit: true,
        valueGetter: "node.rowIndex + 1"
      },
      {
        field: 'title',
        headerName: "Title",
        editable: true,
        cellClass: 'bold-weight',
        wrapText: true,
        autoHeight: true,
        cellStyle: { 'white-space': 'pre-wrap' },
        cellClassRules: {
          'errors': function (params) { return _.isEmpty(params.node.data.title) }
        },
        onCellValueChanged: params => {
          params.api.resetRowHeights();
        },
      },
      {
        field: 'model_number',
        headerName: "Model",
        width: 100,
        editable: true,
        wrapText: true,
        cellStyle: { 'white-space': 'pre-wrap' },
      },
      {
        field: 'tags',
        headerName: "Tags",
        width: 150,
        editable: true,
        cellEditor: "dynamicEditor",
        tooltipField: 'tags',
        wrapText: true,
        autoHeight: true,
        cellStyle: { 'white-space': 'pre-wrap' },
        onCellValueChanged: params => {
          params.api.resetRowHeights();
        },
        cellRenderer(params) {
          if (params.data.tags === undefined || params.data.tags.trim() == "") { return; }
          tags = ""
          params.data.tags.split(",").forEach((tag) => { tags = tags.concat(`<div class='tag__item'>${tag}</div>`) })
          return tags
        }
        // onCellDoubleClicked: event => {
        //   return $('.ag-popup-editor').find('input').val(event.node.data.tags);
        // }
      },
      {
        field: 'image',
        headerName: "Image",
        width: 90,
        minWidth: 90,
        maxWith: 90,
        suppressSizeToFit: true,
        wrapText: true,
        autoHeight: true,
        cellStyle: { 'white-space': 'pre-wrap' },
        onCellValueChanged: params => {
          params.api.resetRowHeights();
        },
        sortable: false,
        onCellClicked: event => {
          var fileElement = document.createElement("input");
          fileElement.type = 'file';
          fileElement.accept = "image/jpeg, image/png";
          fileElement.onchange = function (e) {
            var input = e.target;
            var reader = new FileReader();

            reader.onload = function () {
              var dataURL = reader.result;
              event.node.setDataValue("image", dataURL)
            };
            reader.readAsDataURL(input.files[0]);
          };;
          fileElement.click();
        },
        cellRenderer(params) {
          var resultElement = document.createElement("div");
          if (!params.value) {
            resultElement.className = 'image-input no-image'
          } else {
            var imageElement = document.createElement("img");
            imageElement.src = params.value;
            resultElement.appendChild(imageElement);
            resultElement.className = 'image-input'
          }

          return resultElement;
        }
      },
      {
        field: 'unit',
        headerName: 'unit',
        width: 100,
        cellEditor: "dynamicSelectEditor",
        editable: true,
        wrapText: true,
        autoHeight: true,
        cellStyle: { 'white-space': 'pre-wrap' },
      },
      {
        field: 'specifications',
        headerName: 'Specifications',
        wrapText: true,
        autoHeight: true,
        cellEditor: 'agLargeTextCellEditor',
        cellEditorParams: {
          rows: 5,
          maxLength: 750,
        },
        editable: true,
        width: 250,
        cellStyle: { 'white-space': 'pre-wrap' },
        onCellValueChanged: params => {
          params.api.resetRowHeights();
        }
      },
      {
        field: 'action',
        headerName: '',
        width: 60,
        minWidth: 60,
        maxWith: 60,
        suppressSizeToFit: true,
        resizable: false,
        cellRenderer(params) {
          const link = document.createElement('a');
          link.className = 'icon delete button ico-btn clear';
          link.href = 'javascript:void(0);';

          const div = document.createElement('div');
          div.className = 'actions ico-btns';
          link.onclick = () => DeveloperGrid._removeRow(params);
          div.appendChild(link);

          return div;
        }
      }
    ],
    components: {
      dynamicEditor: getDynamicCellEditor(),
      dynamicSelectEditor: getDynamicSelectEditor()
    }
  },

  _getRowHeightForSpecifications(params) {
    const specifications = params.data.specifications;
    const specificationsLines = Math.floor(specifications.length / 45) + 1;
    return (17 * specificationsLines) + 28;
  },

  _removeRow(params) {
    this._gridOptions.api.applyTransaction({ remove: [params.node.data] });
    if (params.node.data.id) { this._removedRows.push(Object.assign(params.node.data, { _destroy: true })) }
  },

  initializeView(options, key, units) {
    this._units = units
    if (options == null) { options = {}; }
    const gridDiv = document.getElementById('product-requirements-grid');
    agGrid.LicenseManager.setLicenseKey(key);
    suppressLicenseErrorForTestEnvironment();

    if (options.action == 'show') {
      this._gridOptions.columnDefs.map(column => {
        if (column.field == 'action') { column.hide = true }
        column.editable = false
        column.onCellDoubleClicked = false
        column.onCellClicked = false
        return column
      }
      );
    }

    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;
    if (options.data && options.data.requirements) {
      this._gridApi.setGridOption('rowData', options.data.requirements);
    } else {
      this.addRow()
    }

    resizeAgGridTable($('#product-requirements-grid')[0], this._gridOptions, 0, 5);
    this._resizeHorizontally();
    $(window).resize(_.bind(this._resizeHorizontally, this));
    $('#clear').click(_.bind(this.refresh, this));
    $('#add-new-requirement').click(_.bind(this.addRow, this));

    $(document).on('submit', 'form#product-request-form', function (event) {
      if ($('#product_request_import_file').val().length == 0) {
        var rowData = DeveloperGrid._removedRows;
        let error = false;

        DeveloperGrid._gridOptions.api.forEachNode(function (node) {
          if (_.isEmpty(node.data)) { return; }
          if (_.isEmpty(node.data.title)) { error = true }
          rowData.push(node.data);
        });

        if (DeveloperGrid._gridOptions.api.getDisplayedRowCount() == 0 || _.isEmpty(rowData) || error) {
          event.preventDefault()
          showFlashMessage(I18n.t('errors.0008'), 'alert')
          $('form#product-request-form button[type="submit"]').removeClass('processing');
          $('span.spinner').remove();
        }
        element = document.createElement('input')
        element.type = 'hidden'
        element.name = 'product_request[requirements_attributes]'
        element.value = JSON.stringify(rowData)
        $(this).append(element);
      }

      return true;
    })
  },

  _resizeHorizontally() {
    return this._gridApi.sizeColumnsToFit();
  },


  refresh() {
    return window.location = window.location;
  },

  addRow() {
    return this._gridOptions.api.applyTransaction({ add: [{}] });
  },
}
